import React, { useState } from 'react';

interface IProps {
  closeModal: () => void;
}

const TransferOfPersonalInformation: React.FC<IProps> = ({
  closeModal,
}: IProps) => {
  const handleClose = () => {
    closeModal();
  };

  return (
    <div className="dimd-layer">
      <div className="announcement-popup">
        <div className="announcement-header">
          <h2>개인정보 이전 안내</h2>
          <button type="button" className="btn-close" onClick={handleClose}>
            <span className="img-close" />
          </button>
        </div>

        <div className="announcement-content">
          <div className="announcement-text">
            <p>안녕하세요, ㈜로컬스티치입니다.</p>

            <p className="spacing" />

            <p>
              저희 ㈜로컬스티치는 2025년 6월 1일자로 디앤디프라퍼티솔루션(주)와
              합병하며,
            </p>
            <p>
              이로 인해 ㈜로컬스티치가 보유하고 있던 고객님의 개인정보를
              이전하게 되었음을 안내드립니다.
            </p>

            <p className="spacing" />

            <p>■ 개인정보 이전 일자</p>
            <p>- 2025년 6월 1일</p>

            <p className="spacing" />

            <p>■ 이전받은 개인정보 항목</p>
            <p>
              - 성명, 주소, 전화번호, 이메일 주소, 주민등록번호, 결제정보 등
              ㈜로컬스티치가 보유하던 개인정보 일체
            </p>
            <p>
              (※ 실제 이전되는 정보는 귀하가 회원가입 및 서비스 이용 과정에서
              제공하신 범위 내에서 보유 중인 항목에 한합니다.)
            </p>

            <p className="spacing" />

            <p>■ 이전받는 자 정보</p>
            <p>- 법인명: 디앤디프라퍼티솔루션(주)</p>
            <p>- 주소: 서울특별시 강남구 학동로 129</p>
            <p>- 전화번호: 1600-6805</p>
            <p>- 이메일: system@dndproperty.com</p>

            <p className="spacing" />

            <p>■ 개인정보 이용 목적</p>
            <p>
              - 고객님의 개인정보는 이전 후에도 기존과 동일한 목적과 범위
              내에서만 이용되며,
            </p>
            <p>
              제3자 제공이나 목적 외 이용은 관련 법령이 허용하는 경우를
              제외하고는 발생하지 않습니다.
            </p>

            <p className="spacing" />

            <p>■ 개인정보 보호조치</p>
            <p>
              - 당사는「개인정보 보호법」 등 관련 법령에 따라 적절한
              기술적·관리적 보호조치를 시행하여 고객님의 개인정보를 안전하게
              보호할 것을 약속드립니다.
            </p>

            <p className="spacing" />

            <p>■ 개인정보 이전에 대한 이의가 있으신 경우</p>
            <p>
              - 2025년 5월 31일까지 아래 연락처로 이전 거부 의사를 알려주시면,
              관련 절차에 따라 조치해드리겠습니다.
            </p>
            <p>- 고객센터: 02-322-8601</p>
            <p>- 이메일: contact@localstitch.kr</p>

            <p className="spacing" />

            <p>
              ※ 본 안내는「개인정보 보호법」제27조 제2항 및 동법 시행령 제30조에
              따라, 개인정보 이전 사실을 정보주체에게 알리기 위한 법적
              고지입니다.
            </p>

            <p className="spacing" />

            <p>감사합니다.</p>
            <p className="signature">㈜로컬스티치 드림</p>
          </div>
        </div>
      </div>
      <style jsx>{`
        .dimd-layer {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          z-index: 1000;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        .announcement-popup {
          position: relative;
          background-color: white;
          width: 100%;
          max-width: 650px;
          max-height: 90vh;
          overflow-y: auto;
          padding: 40px 30px;
          border-radius: 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .announcement-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
        }

        .btn-close {
          position: static;
          background: none;
          border: none;
          cursor: pointer;
          line-height: 1;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }

        .btn-close .img-close {
          display: block;
          width: 100%;
          height: 100%;
          background-image: url('/images/x-button.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        }

        .announcement-content {
          text-align: left;
        }

        h2 {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 25px;
          text-align: left;
          letter-spacing: -0.5px;
          margin: 0;
        }

        .announcement-text {
          line-height: 1.5;
          margin-bottom: 30px;
          font-size: 15px;
          color: #000;
          letter-spacing: -0.5px;
        }

        .announcement-text p {
          margin-bottom: 5px;
        }

        .spacing {
          height: 10px;
        }

        .signature {
          margin-top: 20px;
          /* text-align: right; */
        }

        .dont-show-again {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #000;
          padding-top: 15px;
          padding-left: 0;
        }

        .checkbox-wrapper {
          display: flex;
          align-items: center;
          padding-left: 0;
          margin-left: 0;
        }

        .dont-show-again input[type='checkbox'] {
          appearance: none;
          -webkit-appearance: none;
          /* width: 16px; */
          /* height: 16px; */
          /* border: 1px solid #000; */
          /* border-radius: 2px; */
          /* margin-right: 8px; */
          margin-left: 0;
          position: relative;
          cursor: pointer;
          vertical-align: middle;
        }

        .dont-show-again input[type='checkbox']:checked {
          background-color: #fff;
          border-color: #ccc;
        }

        .dont-show-again input[type='checkbox']:checked:after {
          content: '';
          position: absolute;
          left: 4px;
          top: 1px;
          width: 5px;
          height: 10px;
          border: solid #333;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        .dont-show-again label {
          font-size: 15px;
          height: 18px;
          line-height: 18px;
          cursor: pointer;
        }

        .dont-show-again button {
          padding-bottom: 1px;
          border-bottom: 1px solid #000;
          cursor: pointer;
          font-size: 15px;
        }

        @media (max-width: 768px) {
          .announcement-popup {
            padding: 30px 20px;
          }

          h2 {
            font-size: 18px;
          }

          .announcement-text {
            font-size: 13px;
          }

          .announcement-popup {
            padding: 30px 20px;
            max-height: 70vh;
          }

          .btn-close .img-close {
            width: 20px;
            height: 20px;
          }

          .dont-show-again {
            font-size: 13px;
          }

          .dont-show-again label {
            font-size: 13px;
          }

          .dont-show-again button {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default TransferOfPersonalInformation;
